"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerProfileContract = void 0;
const contract_1 = require("../base/contract");
const profile_schemas_1 = require("../../schemas/customer/profile.schemas");
const api_schemas_1 = require("../../schemas/base/api.schemas");
exports.CustomerProfileContract = (0, contract_1.createContract)({
    name: 'CustomerProfile',
    baseUrl: '/profile',
    version: '1',
    serviceModule: 'user',
    endpoints: {
        getProfile: {
            method: 'GET',
            path: '/',
            body: null,
            query: null,
            params: null,
            headers: null,
            response: {
                success: profile_schemas_1.getProfileResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                },
            },
            middleware: ['auth:required'],
            documentation: {
                summary: 'Get current user profile',
                description: 'Retrieves the authenticated user profile information',
                tags: ['Customer', 'Profile'],
                deprecated: false,
            },
            tests: ['should return profile for authenticated user', 'should return 401 for unauthenticated request'],
        },
        updateProfile: {
            method: 'PATCH',
            path: '/',
            body: profile_schemas_1.updateProfileBodySchema,
            query: null,
            params: null,
            headers: null,
            response: {
                success: profile_schemas_1.updateProfileResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                    validationError: api_schemas_1.baseErrorResponseSchema,
                },
            },
            middleware: ['auth:required'],
            documentation: {
                summary: 'Update user profile',
                description: 'Updates the authenticated user profile (display name and language preference)',
                tags: ['Customer', 'Profile'],
                deprecated: false,
            },
            tests: ['should update display name', 'should allow setting display name to null', 'should update preferred language'],
        },
        getUserMerchants: {
            method: 'GET',
            path: '/merchants',
            body: null,
            query: null,
            params: null,
            headers: null,
            response: {
                success: profile_schemas_1.getUserMerchantsResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                },
            },
            middleware: ['auth:required'],
            documentation: {
                summary: 'Get user merchants',
                description: 'Retrieves all merchants the authenticated user is a member of',
                tags: ['Customer', 'Profile'],
                deprecated: false,
            },
            tests: ['should return merchants for authenticated user', 'should return empty array if no memberships'],
        },
        deleteAccount: {
            method: 'DELETE',
            path: '/',
            body: null,
            query: null,
            params: null,
            headers: null,
            response: {
                success: profile_schemas_1.deleteAccountResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                },
            },
            middleware: ['auth:required'],
            documentation: {
                summary: 'Delete user account',
                description: 'Permanently deletes the authenticated user account and all associated data. Required by Apple App Store guidelines.',
                tags: ['Customer', 'Profile'],
                deprecated: false,
            },
            tests: [
                'should delete account for authenticated user',
                'should return 401 for unauthenticated request',
            ],
        },
        // ============================================
        // V2 ENDPOINTS (uncomment when ready)
        // ============================================
        /*
        getSettings: {
            method: 'GET',
            path: '/settings',
            body: null,
            query: null,
            params: null,
            headers: null,
            response: {
                success: getSettingsResponseSchema,
                errors: {
                    unauthorized: baseErrorResponseSchema,
                },
            },
            middleware: ['auth:required'],
            documentation: {
                summary: 'Get user settings',
                description: 'Retrieves the authenticated user settings (language preference)',
                tags: ['Customer', 'Profile'],
                deprecated: false,
            },
            tests: ['should return user settings'],
        },
        updateSettings: {
            method: 'PATCH',
            path: '/settings',
            body: updateSettingsBodySchema,
            query: null,
            params: null,
            headers: null,
            response: {
                success: updateSettingsResponseSchema,
                errors: {
                    unauthorized: baseErrorResponseSchema,
                    validationError: baseErrorResponseSchema,
                },
            },
            middleware: ['auth:required'],
            documentation: {
                summary: 'Update user settings',
                description: 'Updates the authenticated user settings (language preference)',
                tags: ['Customer', 'Profile'],
                deprecated: false,
            },
            tests: ['should update preferred language'],
        },
        */
    },
});
